module.exports = __webpack_public_path__ + "static/img/big_border1.96be3082.png";